const fetchData = (id: string): string => `
        {
            manualsSingle(id: "${id}", idType: DATABASE_ID) {
            updateDownloads
        }
    }
`;
export default fetchData;
